import { Button, Dialog, DialogContent, FormControl, MenuItem, Select } from '@mui/material'
import React from 'react'

export default function ConfirmDialogPlanproduction({ open, setOpen, rows, handleAdd,mode, reasons}) {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth='xl'
    >
      <DialogContent>
        <div class="d-flex row align-items-center mb-4">
          <div class="col-12">
            <label style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              color: '#3364af',
            }}>
              {mode === 'review' ? 'รายการทบทวนแผนการผลิต' : 'รายการแผนการผลิต'}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 table-responsive-sm ">
            <table class="table table-borderless table-hover ">
              <thead>
                <tr>
                  <th scope="col " class="text-center">ที่</th>
                  <th scope="col " class="text-center">เมล็ดพันธุ์</th>
                  <th scope="col " class="text-center">ขนิดข้าว</th>
                  <th scope="col " class="text-center">ปริมาณ(กิโลกรัม)</th>
                  {mode === 'review' && <th scope="col " class="text-center">ทบกวน</th>}
                  {mode === 'review' && <th scope="col " class="text-center">เหตุผล</th>}



                </tr>
              </thead>
              <tbody class="">
              {rows?.map((b, i) => (
                <tr >
                  <td class="text-center">{i + 1}</td>
                  <td class="text-center">{b?.ItemNo?.ItemName}</td>
                  <td class="text-center">{b?.TypeNo?.TypeName || b?.ItemNo?.Option1}</td>
                  <td class="text-center">{b.InitialTarget}</td>
                  {mode === 'review' && <td class="text-center">

                    {b.UpdateTarget}</td>}
                  {mode === 'review' && <td class="text-center">
                    <FormControl variant="outlined" size='small' fullWidth  disabled>
                      <Select value={b?.ReasonId || '-'}   >
                        <MenuItem value='-'>-</MenuItem>
                        {reasons?.map((z, i) => (
                          <MenuItem value={z?.ReasonId}>{z?.ReasonName}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </td >}



                </tr >))}
              </tbody >
            </table >
          </div >


        </div >
        <div class="row mt-4">

          <div class="col-12 text-end">
            <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
            <Button onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>ยืนยันการทำรายการ</Button>
          </div >
        </div >
      </DialogContent >
    </Dialog >
  )
}
